import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthProvider";
import Loading from "../../Shared/Loading/Loading";

const MyAppointment = () => {
  const { user } = useContext(AuthContext);

  const url = `https://doctor-portal-server-bice-xi.vercel.app/bookings?email=${user?.email}`;
  const { data: bookings = [], isLoading } = useQuery({
    queryKey: ["bookings", user?.email],
    queryFn: async () => {
      const token = localStorage.getItem("accessToken");
      console.log("Token:", token); // Debug log
      console.log("User email:", user?.email); // Debug log
      
      const res = await fetch(url, {
        headers: {
          authorization: `bearer ${token}`,
        },
      });
      const data = await res.json();
      console.log("Bookings response:", data); // Debug log
      
      // Ensure we always return an array
      if (!Array.isArray(data)) {
        return [];
      }
      return data;
    },
    enabled: !!user?.email, // Only fetch when user email is available
  });

  if (isLoading) {
    return <Loading></Loading>;
  }
  return (
    <div className="overflow-x-auto mt-10">
      <table className="table w-full">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Treatment</th>
            <th>Date</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {bookings &&
            bookings.map((booking, i) => (
              <tr key={booking._id}>
                <th>{i + 1}</th>
                <td>{booking.patient}</td>
                <td>{booking.treatment}</td>
                <td>{booking.appointmentDate}</td>
                <td>{booking.slots}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default MyAppointment;
